<script>
    function goTop() {
        document.body.scrollIntoView();
    }
</script>

<div class="md:hidden fixed bottom-2 font-bold right-3">
    <button on:click="{goTop}" class="bg-white rounded-full border-0 shadow-md shadow-zinc-900">
        <svg class="text-zinc-900 w-10 h-10" viewBox="0 0 24 24">
            <path fill="currentColor" d="M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z" />
        </svg>
    </button>
</div>
